<template>
  <div class="calendar-wrap">
    <div class="view-mode-time" v-show="viewMode === 1" ref="weekTime">
      <div class="time-table" ref="week-time-view">
        <div class="time-col">
          <div class="head" ref="week-date">
            <div class="head-first"></div>
            <div
              class="head-week"
              v-for="(date, index) in eventList"
              :key="date.date"
            >
              <div
                :class="
                  date.date === today ? 'class-hour active' : 'class-hour'
                "
                @click="toDayView(date)"
                :style="`${date.total ? 'cursor:pointer;' : ''}`"
              >
                <p>
                  周{{ ["一", "二", "三", "四", "五", "六", "日"][index] }}
                  {{ date.date.slice(5, 7) }}月{{ date.date.slice(8) }}日
                </p>
                <p>
                  共<span :class="`${date.total ? 'mwow-green' : ''}`">{{
                    date.total
                  }}</span
                  >课次
                </p>
              </div>
            </div>
          </div>
          <div class="visible-wrap" :style="`height:${showViewHeight}px;`">
            <div class="visible-content" :style="`top:-${showViewTop}px;`">
              <div
                class="hour"
                :id="`timejump-week-${index}`"
                v-for="(item, index) in 24"
                :key="index"
              >
                <div class="hour-time">
                  <p>{{ item - 1 >= 10 ? item - 1 : "0" + (item - 1) }}:00</p>
                  <p class="course-statistics">
                    共
                    <span
                      :class="totalTimeCourse[index] === 0 ? '' : 'mwow-green'"
                      >{{ totalTimeCourse[index] }}</span
                    >
                    课次
                  </p>
                </div>
                <div class="day-col" v-for="date in eventList" :key="date.date">
                  <div
                    v-for="(row, ind) in date.lesson_list.filter((leave) => {
                      let sHour = Number(leave.start_time.slice(0, 2));
                      return sHour >= index && sHour < index + 1;
                    })"
                    :key="ind"
                    :style="`background-color: ${
                      row.roll_call_status === 2 ? '#B8B8B8' : row.course.color
                    }`"
                    :class="row.in_holiday === 1 ? 'bias-bgc' : ''"
                  >
                    <slot :lesson="row" type="static"></slot>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import lessonDialog from "../lessonDialog.vue";
// import displayItem from "./displayItem.vue";
import eventBus from "@/utils/bus";
import { dateFormat } from "@/utils/timeFormat";

export default {
  name: "storeScheduleWeekView",
  components: {
    // lessonDialog,
    // displayItem,
  },
  // @Prop() originEvents!: any[];
  // @Prop() originTimeRange!: any[];
  props: ["originEvents", "originTimeRange"],
  // @Watch("originEvents", { immediate: false, deep: false })
  // originEventsChange(n: any[]) {
  //   // 数组传入，刷新视图
  //   this.handleRender(n);
  //   // 时间段展示范围
  //   this.setShowingArea();
  //   this.$nextTick(() => {
  //     if (this.originTimeRange.length > 0) {
  //       this.weekViewOriginevents(this.originTimeRange);
  //     }
  //   });
  // }
  watch: {
    originEvents: {
      handler(n, o) {
        // 数组传入，刷新视图
        this.handleRender(n);
        // 时间段展示范围
        this.setShowingArea();
        this.$nextTick(() => {
          if (this.originTimeRange.length > 0) {
            this.weekViewOriginevents(this.originTimeRange);
          }
        });
      },
      immediate: false,
      deep: false,
    },
  },
  data() {
    return {
      eventList: [],
      resizeMark: false,
      showingAreaRange: [],
      showingAreaHeight: 0,
      showingAreaTop: 0,
      dragDialogData: {},
      viewMode: 1,
      showBtn: 2,
      notLeftClick: true,
      notRightClick: false,
      showViewHeight: 0,
      showViewTop: 0,
      marTop: 0,
      jumpArr: [], // 区域高度数组
      start: 0, // 开始时间
      navigationStart: 0, // 导航栏开始时间
      navigationEnd: 0, //导航栏结束时间
      totalTimeCourse: [], // 时间段课时数
      showNavgation: true, // 展示时间导航
      today: "", // 今天的日期
    };
  },

  mounted() {
    // 视图类型监听
    eventBus.$on("sechdule-view-mode-change", (v) => {
      this.viewMode = v;
    });
  },
  beforeDestory() {
    const el = document.getElementById("layout-content");
    el.removeEventListener("scroll", () => {});
  },
  methods: {
    weekViewOriginevents(v) {
      const name = this.$refs["week-date"];
      const w_t_v = this.$refs["week-time-view"];
      const el = document.getElementById("layout-content");
      const wrap = document.getElementById("time-view-search-form");
      el.addEventListener("scroll", () => {
        if (!wrap) {
          return false;
        }
        // if (el.scrollTop >= wrap.clientHeight + 128) {
        if (el.scrollTop >= wrap ? wrap.clientHeight + 128 : 0) {
          if (w_t_v.clientWidth !== 0) {
            name.style.width = w_t_v.clientWidth + "px";
          }
          name.classList.add("top-regular");
          name.scrollTo(20, 0);
        } else {
          name.classList.remove("top-regular");
        }
      });
      const startTime = Number(v[0].slice(0, 2));
      let endTime = Number(v[1].slice(0, 2));
      const endminute = Number(v[1].slice(3, 5));
      if (endminute > 0 && endTime > 23) {
        endTime += 1;
      }
      this.navigationStart = startTime;
      this.navigationEnd = endTime;
      let viewHight = 0;
      let viewTop = 0;
      const hightArr = [];
      const topArr = [];
      for (let i = startTime; i <= endTime; i++) {
        if (document.getElementById(`timejump-week-${i}`)?.clientHeight) {
          hightArr.push(
            document.getElementById(`timejump-week-${i}`)?.clientHeight
          );
        }
      }
      for (let i = 0; i < startTime; i++) {
        topArr.push(
          document.getElementById(`timejump-week-${i}`)?.clientHeight
        );
      }
      if (hightArr.length > 0) {
        hightArr.map((item) => {
          viewHight += item;
        });
        this.showViewHeight = viewHight;
        this.jumpArr = hightArr;
        this.start = startTime;
      }
      if (topArr.length > 0) {
        topArr.map((item) => {
          viewTop += item;
        });
        viewTop += topArr.length;
        this.showViewTop = viewTop;
      }
      const totalArr = [];
      for (let i = 0; i < 24; i++) {
        totalArr.push(0);
      }
      this.eventList.map((item) => {
        item.lesson_list.map((it) => {
          const hours = Number(it.start_time.slice(0, 2));
          totalArr[hours] += 1;
        });
      });
      this.totalTimeCourse = totalArr;
      // 判断整个时间段是否有数据
      const nArr = [...totalArr];
      const newArr = nArr.sort((a, b) => a - b);
      if (newArr[newArr.length - 1] > 0) {
        this.showNavgation = true;
      } else {
        this.showNavgation = false;
      }
    },
    navigation(ind) {
      const bl = document.getElementById("layout-content");
      const num = ind - this.start;
      if (num > 0) {
        let toNum = 280;
        for (let i = 0; i < num - 1; i++) {
          toNum += this.jumpArr[i];
        }
        bl.scrollTo(0, toNum);
      }
    },
    handleTableScroll(v) {
      if (v === "left") {
        const el = this.$refs["week-time-view"];
        el.scrollLeft -= 960;
        if (el.scrollLeft === 0) {
          this.notLeftClick = true;
        } else {
          this.notLeftClick = false;
        }
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 20) {
          this.notRightClick = true;
        } else {
          this.notRightClick = false;
        }
      }
      if (v === "right") {
        const el = this.$refs["week-time-view"];
        el.scrollLeft += 960;
        if (el.scrollLeft + el.clientWidth >= el.scrollWidth - 20) {
          this.notRightClick = true;
        } else {
          this.notRightClick = false;
        }
        if (el.scrollLeft === 0) {
          this.notLeftClick = true;
        } else {
          this.notLeftClick = false;
        }
      }
    },
    setShowingArea() {
      if (this.originTimeRange.length === 0) {
        return false;
      }
      const start = this.originTimeRange[0];
      const end = this.originTimeRange[1];
      // 计算展示范围
      const firstH = 18; // 一分钟行高
      const rshms = start.split(":");
      const startLine =
        Number(rshms[0]) * 60 * 60 + Number(rshms[1]) * 60 + Number(rshms[2]);
      const rehms = end.split(":");
      const endLine =
        Number(rehms[0]) * 60 * 60 + Number(rehms[1]) * 60 + Number(rehms[2]);
      this.showingAreaTop = (startLine / (24 * 60 * 60)) * firstH * 6 * 24;
      this.showingAreaHeight =
        ((endLine - startLine) / (24 * 60 * 60)) * firstH * 6 * 24;
      // this.handleRender();
    },
    handleRender(arr) {
      const originData = arr || this.originEvents;
      const firstH = 18; // 一分钟行高
      // 计算event定位
      const resArray = [];
      originData.map((date, index) => {
        if (dateFormat("YYYY-mm-dd", new Date()) === date.date) {
          date.today = true;
        }
        const rows = []; // 当前遍历行集合
        let curRow = {
          // 当前遍历行
          lessons: [],
          margin: "0",
          start: 0,
        };
        let arrEnd = new Date(date.date.replace(/-/g, "/")).getTime(); // 当前遍历结束时间，默认为遍历日期0点
        date.lesson_list.map((lesson, index) => {
          const curStart = new Date(
            date.date.replace(/-/g, "/") + " " + lesson.start_time
          ).getTime();
          const curEnd = new Date(
            date.date.replace(/-/g, "/") + " " + lesson.end_time
          ).getTime();
          lesson.height = ((curEnd - curStart) / 600000) * firstH;
          lesson.display = [];
          lesson.start_number = curStart;
          lesson.end_number = curEnd;
          if (curRow.lessons.length === 0) {
            lesson.margin = 0;
            curRow = {
              lessons: [lesson],
              margin: ((curStart - arrEnd) / 600000) * firstH,
              start: curStart,
            };
          } else {
            if (curStart >= arrEnd) {
              // 当前课时开始时间开始大于当前行结束时间时，换行
              // 处理行内布局
              const res = {
                display: [],
              };
              curRow.lessons.map((lesson) => {
                this.solveDisplay(lesson, res);
              });
              curRow.display = res.display;
              rows.push(curRow);
              lesson.margin = 0;
              curRow = {
                lessons: [lesson],
                margin: ((curStart - arrEnd) / 600000) * firstH,
                start: curStart,
              };
            } else {
              lesson.margin = ((curStart - curRow.start) / 600000) * firstH;
              curRow.lessons.push(lesson);
            }
          }
          arrEnd = curEnd > arrEnd ? curEnd : arrEnd;
          if (index === date.lesson_list.length - 1) {
            // 最后一项时
            const res = {
              display: [],
            };
            curRow.lessons.map((lesson) => {
              this.solveDisplay(lesson, res);
            });
            curRow.display = res.display;
            rows.push(curRow);
          }
        });
        resArray.push({
          ...date,
          rows,
        });
      });
      this.eventList = resArray;
      this.todaytime();
    },
    todaytime() {
      const day = new Date();
      this.today = dateFormat("YYYY-mm-dd", day);
    },
    solveDisplay(lesson, res) {
      if (res.display.length === 0) {
        res.display.push(lesson);
      } else {
        // 算出res的最低组序号和最低值
        const minArray = {
          array: [],
        };
        this.getMinEnd(res.display, "", minArray);
        minArray.array.sort((a, b) => {
          return a.end_number - b.end_number;
        });
        const minEnd = minArray.array[0].end_number;
        const minIndex = minArray.array[0].index.split("-");
        if (minIndex.length > 1) {
          this.solveDisplay(lesson, res.display[Number(minIndex[0])]);
        } else {
          if (lesson.start_number > minEnd) {
            this.solveDisplay(lesson, res.display[Number(minIndex[0])]);
          } else {
            res.display.push(lesson);
          }
        }
      }
    },
    getMinEnd(groups, index, res) {
      if (groups.length > 0) {
        groups.map((it, idx) => {
          if (it.display.length > 0) {
            this.getMinEnd(it.display, (index || "") + idx + "-", res);
          } else {
            res.array.push({
              end_number: it.end_number,
              index: (index || "") + idx,
            });
          }
        });
      }
    },
    handleDragStart(e, lesson) {
      const ref = document.getElementById(`event-${lesson.lesson_id}`);
      ref.style.display = "block";
      this.dragDialogData = {
        ...lesson,
        x: e.x,
        y: e.y,
      };
    },
    handleDrop(date, e) {
      const ref = document.getElementById(
        `event-${this.dragDialogData.lesson_id}`
      );
      ref.style.display = "none";
      const tdH = 18;
      let week = new Date(this.dragDialogData.date.replace(/-/g, "/")).getDay();
      week = week === 0 ? 7 : week;
      const startY = this.dragDialogData.y;
      const endY = e.y;
      const distanceY = endY - startY;
      const stepY = Math.floor(distanceY / tdH);
      const resDate = date.date;
      // 判断时间
      const oldStartTime = new Date(
        this.dragDialogData.date.replace(/-/g, "/") +
          " " +
          this.dragDialogData.start_time
      ).getTime();
      const oldEndTime = new Date(
        this.dragDialogData.date.replace(/-/g, "/") +
          " " +
          this.dragDialogData.end_time
      ).getTime();
      const resTimeStart = dateFormat(
        "HH:MM:SS",
        oldStartTime + stepY * 10 * 60 * 1000
      );
      const resTimeEnd = dateFormat(
        "HH:MM:SS",
        oldEndTime + stepY * 10 * 60 * 1000
      );
      this.$emit("lesson-date-change", {
        ...this.dragDialogData,
        new_date: resDate,
        new_start_time: resTimeStart,
        new_end_time: resTimeEnd,
      });
    },
    toDayView(date) {
      if (date.total) {
        eventBus.$emit("schecule-switch-to-day-view", date.date);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.calendar-wrap {
  height: 100%;
  .view-mode-time {
    .head {
      border: 1px solid #e7e8ea;
      color: #5c5d5e;
      text-align: center;
      box-sizing: border-box;
      padding-top: 2px;
      line-height: 18px;
      height: 40px;
      background-color: #f2f6fa;
      display: flex;
      .head-first {
        width: 99px;
        border-right: 1px solid #e7e8ea;
      }
      .head-week {
        flex: 1;
        border-right: 1px solid #e7e8ea;
      }
      :last-child {
        border-right: none;
      }
    }
    .visible-wrap {
      border: 1px solid #e7e8ea;
      margin-top: -1px;
      position: relative;
      overflow: hidden;
      .visible-content {
        position: absolute;
        width: 100%;
        .hour {
          display: flex;
          text-align: center;
          border-bottom: 1px solid #e7e8ea;
          .hour-time {
            color: #5c5d5e;
            width: 100px;
            border-right: 1px solid #e7e8ea;
            min-height: 54px;
            padding-top: 8px;
            box-sizing: border-box;
            .course-statistics {
              padding-top: 8px;
            }
          }
          .day-col {
            flex: 1;
            border-right: 1px solid #e7e8ea;
            padding: 5px;
          }
          :last-child {
            border-right: none;
          }
        }
      }
    }
  }
}
.top-regular {
  position: fixed;
  top: 54px !important;
  z-index: 100;
}
.active {
  background-color: #f0fdfa;
}
</style>
